import { useState } from "react";
import {
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

const ServiceFaq = ({ service }) => {
  const [active, setActive] = useState(0);

  if (!service.faqs?.length) return null;

  return (
    <section className="py-24 bg-slate-50">
      <div className="container-custom">

        <div className="text-center mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            FAQ
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Frequently Asked Questions
          </h2>

        </div>

        <div className="max-w-4xl mx-auto">

          {service.faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl mb-5 overflow-hidden border border-gray-100"
            >

              <button
                onClick={() =>
                  setActive(active === index ? null : index)
                }
                className="w-full flex justify-between items-center p-6 text-left"
              >
                <h3 className="font-semibold text-[#082B57]">
                  {faq.question}
                </h3>

                {active === index ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )}
              </button>

              {active === index && (
                <div className="px-6 pb-6 text-gray-600 leading-8">
                  {faq.answer}
                </div>
              )}

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ServiceFaq;